import { ERROR_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Error/config";
import { ERRORS_TRANSLATION_NAMESPACE } from "../../config";
import errorComponentsTranslations from "./components-error.en-GB.json";
import errorsTranslations from "./errors.en-GB.json";

export const enGBTranslations = {
    [ERRORS_TRANSLATION_NAMESPACE]: errorsTranslations,
    [ERROR_COMPONENTS_TRANSLATION_NAMESPACE]: errorComponentsTranslations,
};
